import { Form } from 'antd';

export default Form;



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/form.js